import React, { useEffect } from "react";
import Toast from "components/Toast";
import { useDispatch } from "react-redux";
import { closeToast } from "stores/toast/slice.toast";

const ToastContainer = ({ toasts }) => {

  const dispatch = useDispatch()

  useEffect(() => {
    const timers = toasts.map((toast) => {
      return setTimeout(() => {
        dispatch(closeToast(toast.id));
      }, 3000); 
    });

    return () => {
      timers.forEach((timer) => clearTimeout(timer));
    };
  }, [toasts, dispatch]);

  return (
    <div
      style={{
        position: "fixed",
        top: "11%",
        right: "1%",
        zIndex: 1000 // Đảm bảo nó nằm trên các thành phần khác
      }}
    >
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          type={toast.type}
          message={toast.message}
          onClose={() => dispatch(closeToast(toast.id))}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
